export const SHADOW_DIAGNOSTIC_ENABLED =
  process.env.NODE_ENV === 'development'
  && process.env.REACT_APP_SHADOW_DIAGNOSTIC === 'true';

// FIX-RANK.a — déverrouillé en production.
// Valeur par défaut : true (backend est la source de vérité).
// Surcharge via REACT_APP_USE_BACKEND_RANKING=false pour debug/maintenance.
export const USE_BACKEND_RANKING =
  process.env.REACT_APP_USE_BACKEND_RANKING !== 'false';

export const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8001";
